import { Location } from 'history';
import { useEffect, useRef } from 'react';
import { useRouter } from './useRouter';

export type BlockCheck = (
  prevLocation: Location,
  nextLocation: Location | null
) => string | null | undefined | false | void;

export const useBlockOnRouteChange = (shouldBlock: BlockCheck) => {
  const { history, location: initialLocation } = useRouter();
  const prevLocRef = useRef<Location>(initialLocation);
  useEffect(() => {
    const unlisten = history.listen((location) => {
      prevLocRef.current = location;
    });

    const unblock = history.block((location) => {
      return shouldBlock(prevLocRef.current, location) || undefined;
    });
    const unloader = (e: Event) => {
      const block = shouldBlock(prevLocRef.current, null);
      if (block) {
        e.preventDefault();
        e.returnValue = true;
      } else {
        // @ts-ignore
        delete e['returnValue'];
      }
    };
    window.addEventListener('beforeunload', unloader);
    return () => {
      unlisten();
      unblock();
      window.removeEventListener('beforeunload', unloader);
    };
  }, [shouldBlock, history]);
};
